<button button-generic [button-style]="'teal'" [border-radius]="'circle'" [icon]="true" (click)="changeTheme()" tooltip="Switch to {{uiService.mode() == UIMode.Dark ? 'Light' : 'Dark'}} mode" tooltip-placement="right">
    @if(uiService.mode() == UIMode.Dark){
        <fa-icon [icon]="['fad', 'sun-bright']"/>
    }
    @else if(uiService.mode() == UIMode.Light){
        <fa-icon [icon]="['fass', 'moon']"/>
    }
</button>